<template>
  <section class="layout-general">
    <div v-for="item of data" :key="item.productId" class="item">
      <div class="header">
        <div>
          <div class="title">
            <svg-icon :icon-class="`product-icon-${item.productName_zh_CN}`" />
            <span>{{ item.productName }}</span>
          </div>
          <div v-if="item.memo" class="desc">{{ item.memo }}</div>
        </div>
        <div>
          <action-buttons :product-name="item.productName_zh_CN" />
        </div>
      </div>
      <div class="body">
        <img
          :src="`${assetsPathBase}/products-fig-${item.productId}.png`"
          :alt="item.memo || item.productName"
          loading="lazy"
          @error="event => (event.target.style.opacity = 0)"
        />
      </div>
    </div>
  </section>
</template>

<script>
import ActionButtons from "./action-buttons.vue";
import { commons } from "./mixin";
export default {
  name: "LayoutGeneral",
  components: {
    ActionButtons
  },
  mixins: [commons],
  props: {
    data: {
      type: Array,
      default() {
        return [];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../styles/common";
.layout-general {
  display: flex;
  gap: 16px;
  .item {
    display: flex;
    flex-direction: column;
    width: calc(50% - 8px);
    background: #f7f8fa;
    border-radius: 8px;
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 24px;
      padding: 24px 30px 0 30px;
      .title {
        display: flex;
        align-items: center;
        gap: 4px;
        margin-bottom: 4px;
        color: $color-text-primary;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        svg {
          width: 24px;
          height: 24px;
          color: $color-blue;
        }
      }
      .desc {
        color: $color-text-regular;
        font-size: 12px;
        line-height: 18px;
      }
    }
    .body {
      flex-grow: 1;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        user-select: none;
        pointer-events: none;
      }
    }
  }
}
</style>
